module.exports = __webpack_public_path__ + "img/logo.a4484d51.svg";